import React, { Component, PropTypes } from 'react';

class Footer extends Component {
    render() {
        return <div></div>;
    }
}

Footer.propTypes = {
    // intl: intlShape,
    // className: PropTypes.string,
    // onSelect: PropTypes.func,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/layout/Footer.js